export default "__VITE_ASSET__cb2e53ce__"